import { find, findIndex, isNumber } from "lodash";
import { SSOAction, SSO_AUTH_URL, SSO_ORIGIN } from "./constants";
import {
  ISSOMessageRequest,
  ISSOMessageResponse,
  ISSOUser,
} from "./services/typings";

export const sendMsgEvent = (requestMsg: ISSOMessageRequest): Promise<any> => {
  return new Promise((resolve, reject) => {
    const messageChannel = new MessageChannel();
    const ssoHiddenIframe: HTMLIFrameElement = document.getElementById(
      "sso-hidden-frame"
    ) as any;
    if (ssoHiddenIframe) {
      const transferer = messageChannel.port1;
      transferer.onmessage = (event: MessageEvent<ISSOMessageResponse>) => {
        if (!event.origin || event.origin === SSO_ORIGIN) {
          const { action, status, payload, error } = event.data;
          if (action === requestMsg.action) {
            if (status === "SUCCESS") {
              resolve(payload);
            } else {
              reject(error);
            }
          } else {
            // throw new Error();
          }
        } else {
          // throw new Error();
        }
      };
      ssoHiddenIframe.contentWindow?.postMessage(requestMsg, SSO_AUTH_URL, [
        messageChannel.port2,
      ]);
    } else {
      reject(new Error("Missing SSO"));
    }
  });
};

export const getAccessTokenByCustomerId = async (
  id: number
): Promise<string | null> => {
  const users: ISSOUser[] = (await getAccountList())?.accounts;
  // eslint-disable-next-line eqeqeq
  const index = find(users, (user) => user.customerId == id)?.accountIndex;
  if (isNumber(index) && index > -1)
    return (await getAccessToken(index)).accessToken;
  else {
    return null;
  }
};

export const getInfoByCustomerId = async (
  id: number
): Promise<string | null> => {
  const users: ISSOUser[] = (await getAccountList())?.accounts;
  // eslint-disable-next-line eqeqeq
  const index = find(users, (user) => user.customerId == id)?.accountIndex;
  if (isNumber(index) && index > -1) return await getAccessToken(index);
  else {
    return null;
  }
};

export const getAccessToken = (accountIndex: number) =>
  sendMsgEvent({
    action: SSOAction.GET_ACCESS_TOKEN,
    payload: accountIndex,
  });

export const getAccountList = () =>
  sendMsgEvent({
    action: SSOAction.GET_ACCOUNT_LIST,
  });
